import React from 'react';
import Button from 'Douleutaras/components/Button';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

import './NotFound.scss';

const ErrorScreen = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Helmet>
        <title>
          404
        </title>
      </Helmet>
      <div styleName="error-page-intro-inner">
        <article styleName="error-page-info">
          <div styleName="error-page-preview">
            <img
              src={`${process.env.ASSETS_CDN_PATH}/douleutaras/img/vendor/v1/icon-error-404.svg`}
              alt="" />
          </div>
          <h1 styleName="error-page-title">
            <span>{t('Ουπς!')}</span> {t('Κάτι πήγε στραβά.')}
          </h1>
          <div styleName="error-page-action">
            <Button href="/" type="Primary">
              {t('Μεταβαση στην κεντρική σελίδα')}
            </Button>
          </div>
        </article>
      </div>
    </div>
  );
};

export default ErrorScreen;
